function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.8701172mm",
    height: "7.6435308mm",
    viewBox: "0 0 4.8701172 7.6435308",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.56266,-58.155869)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 39.115398,64.309158 q 0.214844,0.200196 0.478516,0.297852 0.263671,0.09277 0.600585,0.09277 0.903321,0 1.489258,-0.498047 0.590821,-0.502929 0.590821,-1.259765 0,-0.59082 -0.385743,-0.917969 -0.385742,-0.332031 -1.074218,-0.332031 -0.405274,0 -0.854493,0.09277 -0.449218,0.08789 -0.493164,0.08789 -0.136718,0 -0.205078,-0.06836 -0.06836,-0.06836 -0.06836,-0.205079 0,-0.06836 0.219726,-1.079101 0.219727,-1.015625 0.405274,-1.938477 0.385742,0.02441 0.683594,0.03906 0.297851,0.0098 0.551757,0.0098 0.722657,0 1.181641,-0.05371 0.458984,-0.05859 0.742188,-0.170898 0.07324,0.131836 0.107421,0.253906 0.03906,0.117188 0.03906,0.219727 0,0.3125 -0.244141,0.429687 -0.239257,0.112305 -1.103515,0.112305 -0.317383,0 -0.65918,-0.0049 -0.341797,-0.0098 -0.712891,-0.02441 -0.04883,0.263672 -0.131836,0.688477 -0.08301,0.424804 -0.200195,0.981445 0.307617,-0.05859 0.541992,-0.08301 0.234375,-0.0293 0.410157,-0.0293 0.996093,0 1.577148,0.507813 0.581055,0.507812 0.581055,1.37207 0,0.483399 -0.175782,0.917969 -0.170898,0.43457 -0.493164,0.761719 -0.502929,0.517578 -1.142578,0.78125 -0.639648,0.258789 -1.376953,0.258789 -0.55664,0 -0.86914,-0.151367 -0.3125,-0.15625 -0.3125,-0.424805 0,-0.12207 0.07324,-0.288086 0.07813,-0.166016 0.229492,-0.375977 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit5);
export default __webpack_public_path__ + "static/media/digit-5.fae22a8e34664ef80441d6c436a47e4d.svg";
export { ForwardRef as ReactComponent };